import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';

export default class UserPage extends React.Component {
	render() {
		return (
			<DocumentTitle title="Uživatelé">
				<TabbablePage
					module="user"
					List={List}
					Form={Form}
					newTitle="Nový"
					listTitle="Seznam uživatelů"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/User/Page.js